import { Grid } from '@mui/material'
import { ButtonLarge } from 'src/components/ButtonLarge'
import { TypographyComponent } from 'src/components/Typography'
import styled, { css } from 'styled-components'
import theme from '../../styles/theme'

export const ContainerFlex = styled('form')(
  () => css`
    display: flex;
    gap: ${theme.layout.gap.base * 10}rem;
    width: 100%;

    @media (max-width: ${theme.screen.large}) {
      max-width: 100%;
    }
  `
)

export const ContainerImage = styled('div')(
  () => css`
    @media (max-width: ${theme.screen.medium}) {
      display: none;
    }
  `
)

export const Content = styled('div')(
  () => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${theme.layout.gap.base * 5}rem;
    width: 80%;

    @media (max-width: ${theme.screen.large}) {
      width: 100%;
    }
  `
)

export const Title = styled('h1')(
  () => css`
    font-size: ${theme.typograph.fontsize.h8};
  `
)

export const Typography = styled(TypographyComponent)(
  () => css`
    && {
      font-size: ${theme.typograph.fontsize.h6};
      font-weight: 300;
      width: 75%;
      span {
        font-weight: 700;
      }

      @media (max-width: ${theme.screen.small}) {
        width: 100%;
      }
    }
  `
)

export const GridContainer = styled(Grid)(
  () => css`
    width: 100%;
    @media (min-width: ${theme.screen.medium}) {
      width: 50%;
    }
  `
)

export const ButtonContainer = styled('div')(
  () => css`
    display: flex;
    flex-direction: column;
  `
)

export const Button = styled(ButtonLarge)(
  () => css`
    width: 25%;

    @media (min-width: ${theme.screen.medium}) {
      width: 50%;
    }
  `
)
